import { Component, Inject, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { LoginOrganizationSite } from '../../../../api/models/login-organization-site';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogActions } from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-filter-user-sites',
    templateUrl: './filter-user-sites.component.html',
    styleUrls: ['./filter-user-sites.component.scss'],
    imports: [
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCheckbox,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatDialogActions,
        MatButton,
        TranslateModule,
    ],
})
export class FilterUserSitesComponent implements OnInit {
    dataSource = new MatTableDataSource<LoginOrganizationSite>();
    selection = new SelectionModel<LoginOrganizationSite>(true, []);

    displayedColumns = ['select', 'name', 'address'];

    // TODO: Set Location selection limit
    readonly MAX_LOCATIONS = 10;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        private data: {
            sites: LoginOrganizationSite[];
            currentlySelectedSites: LoginOrganizationSite[] | string[];
        },
        private dialogRef: MatDialogRef<FilterUserSitesComponent>
    ) {}

    ngOnInit(): void {
        this.dataSource.data = this.data.sites;

        console.log(
            'FilterUserSitesComponent: Initializing with data:',
            this.data
        );
        console.log(
            'FilterUserSitesComponent: Available sites:',
            this.data.sites.map(s => ({ key: s._key, name: s.name }))
        );
        console.log(
            'FilterUserSitesComponent: Currently selected sites:',
            this.data.currentlySelectedSites
        );

        if (
            this.data.currentlySelectedSites &&
            this.data.currentlySelectedSites.length > 0
        ) {
            const selectedOrgSites: LoginOrganizationSite[] = [];

            // Check if we have strings or objects by examining the first element
            const firstElement = this.data.currentlySelectedSites[0];
            const isStringArray = typeof firstElement === 'string';

            console.log(
                'FilterUserSitesComponent: First element type:',
                typeof firstElement
            );
            console.log(
                'FilterUserSitesComponent: Is string array:',
                isStringArray
            );

            if (isStringArray) {
                // Handle string[] format (site keys)
                (this.data.currentlySelectedSites as string[]).forEach(
                    siteKey => {
                        console.log(
                            'FilterUserSitesComponent: Looking for site with key:',
                            siteKey
                        );
                        const foundSite = this.data.sites.find(
                            element => element._key === siteKey
                        );
                        if (foundSite) {
                            selectedOrgSites.push(foundSite);
                            console.log(
                                'FilterUserSitesComponent: Found and added site:',
                                foundSite.name
                            );
                        } else {
                            console.warn(
                                'FilterUserSitesComponent: Site not found for key:',
                                siteKey
                            );
                        }
                    }
                );
            } else {
                // Handle LoginOrganizationSite[] format
                selectedOrgSites.push(
                    ...(this.data
                        .currentlySelectedSites as LoginOrganizationSite[])
                );
                console.log(
                    'FilterUserSitesComponent: Added sites directly:',
                    selectedOrgSites.map(s => s.name)
                );
            }

            console.log(
                'FilterUserSitesComponent: Final selected sites for selection:',
                selectedOrgSites
            );
            this.selection.select(...selectedOrgSites);

            // Verify selection worked
            console.log(
                'FilterUserSitesComponent: Selection after select:',
                this.selection.selected.map(s => s.name)
            );
        } else {
            console.warn(
                'FilterUserSitesComponent: No currentlySelectedSites provided or array is empty'
            );
        }
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }

        // Select up to MAX_LOCATIONS or all rows, whichever is smaller
        const rowsToSelect = this.dataSource.data.slice(0, this.MAX_LOCATIONS);
        this.selection.select(...rowsToSelect);
    }

    // Check if we can select more locations
    canSelectMore(): boolean {
        return this.selection.selected.length < this.MAX_LOCATIONS;
    }

    // Check if a specific row can be selected
    canSelectRow(row: LoginOrganizationSite): boolean {
        return this.selection.isSelected(row) || this.canSelectMore();
    }

    // Handle single row toggle with limit check
    toggleRow(row: LoginOrganizationSite): void {
        if (this.selection.isSelected(row)) {
            // Always allow deselection
            this.selection.deselect(row);
        } else if (this.canSelectMore()) {
            // Only allow selection if under limit
            this.selection.select(row);
        }
        // Do nothing if at limit and trying to select
    }

    // Get current selection count
    getSelectedCount(): number {
        return this.selection.selected.length;
    }

    // Check if at maximum selections
    isAtMaxSelections(): boolean {
        return this.selection.selected.length >= this.MAX_LOCATIONS;
    }

    confirm() {
        this.dialogRef.close(this.selection.selected);
    }

    siteAdress(site: LoginOrganizationSite) {
        if (site.address) {
            return site.address;
        } else if (site.location) {
            return `${site.location.street}, ${site.location.zipCode} ${site.location.city}`;
        } else {
            return '';
        }
    }
}
